module.exports = __webpack_public_path__ + "img/8.4e3a7b09.jpg";